import React from 'react';
import {RoutePermittedRole} from '../../constants/AppEnums';
import Account from '../../modules/profile';

export const accountPagesConfigs = [
  {
    permittedRole: RoutePermittedRole.UserRole,
    path: '/profile',
    element: <Account />,
  },
];
